module.exports = __webpack_public_path__ + "img/guidbg.84bde73b.jpg";